import { createRouter, createWebHistory } from 'vue-router';
import { message } from '🔗/utils/utils';
// import { message, isMobile } from '🔗/utils/utils';

// import stores from '@/stores';
// import api from '🔗/api';

import { requests } from '🔗/utils/requests';

const handleRouterError = (error) => {
    const t = stores.locale().t();
    const errors = [
        {
            code: ['fetch', 'load', 'dynamically', 'importing'],
            action: () => message.error(t('common.errors.importError'))
        }
    ];

    const errorWords = error.message.toLowerCase().split(' ');
    const action = errors.find((item) => item.code.some((r) => errorWords.indexOf(r) !== -1));

    if (action) {
        return action.action();
    } else {
        message.error(error.message);
    }
};

const routes = [
    {
        path: '/',
        name: '/',
        component: () => import('../pages/Main/Main.vue'),
        abort: []
    }
];

const router = createRouter({
    history: createWebHistory(import.meta.env.VITE_APP_BASE_URL),
    routes
});

router.back = function (path) {
    this.options?.history?.state?.back ? this.go(-1) : this.push(path || '/');
};

router.beforeEach((to, from, next) => {
    if (stores.modals().back()) {
        next(false);
        return;
    }

    if (from?.name) {
        routes.forEach((item) => {
            if (item?.name === from?.name && item.abort?.length) {
                item.abort.forEach((code) => {
                    if (code.split(':id').length === 1) {
                        requests[code].abort();
                    } else {
                        requests[code.split(':id')[0]].abort(from.params.id);
                    }
                });
            }
        });
    }

    if (to?.name && stores.nav().page !== to.name) {
        stores.nav().setPage(to.name);
    }
    next();
});

router.onError(handleRouterError);

export default router;
